import styled from 'styled-components';

import { RegularSm } from 'modules/ui/typography';

export const BadgeContainer = styled.div<{ color: string }>`
  height: 28px;
  width: fit-content;
  display: inline-flex;
  align-items: center;
  border-radius: 100px;
  background-color: ${({ color }): string => color};
  box-sizing: border-box;
  padding: 0 12px;
`;

export const BadgeLabel = styled(RegularSm)<{ labelColor: string }>`
  color: ${({ labelColor }): string => labelColor};
  text-transform: capitalize;
`;
